var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                "label-col": _vm.labelCol2,
                "wrapper-col": _vm.wrapperCol2,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.personid"],
                            prop: "personid"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              disabled: _vm.operation.visible,
                              placeholder: this.language["cs.person.personid"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.personid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "personid", $$v)
                              },
                              expression: "model.personid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.pname"],
                            prop: "pname"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.person.pname"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.pname,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "pname", $$v)
                              },
                              expression: "model.pname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.sex"],
                            prop: "sex"
                          }
                        },
                        [
                          _c(
                            "a-Select",
                            {
                              attrs: {
                                "allow-clear": "",
                                "show-search": "",
                                optionFilterProp: "children",
                                placeholder: this.language["cs.person.sex"]
                              },
                              model: {
                                value: _vm.model.sex,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "sex", $$v)
                                },
                                expression: "model.sex"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "M" } }, [
                                _vm._v("男")
                              ]),
                              _c("a-select-option", { attrs: { value: "F" } }, [
                                _vm._v("女")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.jobname"],
                            prop: "jobname"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.person.jobname"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.jobname,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "jobname", $$v)
                              },
                              expression: "model.jobname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.deptname"],
                            prop: "deptname"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.person.deptname"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.deptname,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "deptname", $$v)
                              },
                              expression: "model.deptname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.phone"],
                            prop: "phone"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.person.phone"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "phone", $$v)
                              },
                              expression: "model.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.email"],
                            prop: "email"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.person.email"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.person.workno"],
                            prop: "workno"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.person.workno"],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.workno,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "workno", $$v)
                              },
                              expression: "model.workno"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShow,
                          expression: "isShow"
                        }
                      ],
                      attrs: { span: 12 }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.activity.activityname"],
                            prop: "sysactivityid"
                          }
                        },
                        [
                          _c("a-Select", {
                            attrs: {
                              disabled: _vm.operation.visible,
                              options: _vm.selectActivityList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language[
                                "cs.activity.activityname"
                              ]
                            },
                            on: { change: _vm.handChageActivity },
                            model: {
                              value: _vm.model.sysactivityid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sysactivityid", $$v)
                              },
                              expression: "model.sysactivityid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShow,
                          expression: "isShow"
                        }
                      ],
                      attrs: { span: 12 }
                    },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.venue.venuename"],
                            prop: "sysvenueid"
                          }
                        },
                        [
                          _c("a-Select", {
                            attrs: {
                              options: _vm.selectVenueList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language["cs.venue.venuename"]
                            },
                            model: {
                              value: _vm.model.sysvenueid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sysvenueid", $$v)
                              },
                              expression: "model.sysvenueid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["cs.seatgroup.sgroupname"],
                            prop: "syspgid"
                          }
                        },
                        [
                          _c("a-Select", {
                            attrs: {
                              options: _vm.selectPgList,
                              "allow-clear": "",
                              "show-search": "",
                              optionFilterProp: "children",
                              placeholder: this.language[
                                "cs.seatgroup.sgroupname"
                              ]
                            },
                            model: {
                              value: _vm.model.syspgid,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "syspgid", $$v)
                              },
                              expression: "model.syspgid"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            "label-col": _vm.labelCol1,
                            "wrapper-col": _vm.wrapperCol1,
                            label: this.language["cs.person.sourcedesc"],
                            prop: "sourcedesc"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "cs.person.sourcedesc"
                              ],
                              maxLength: "50"
                            },
                            model: {
                              value: _vm.model.sourcedesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sourcedesc", $$v)
                              },
                              expression: "model.sourcedesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            "label-col": _vm.labelCol1,
                            "wrapper-col": _vm.wrapperCol1,
                            label: this.language["cs.remark"],
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.remark"],
                              maxLength: "150"
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }